import { Modal, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import CircularProgress from "../../components/CircularProgress";
import KTSVG from "../../components/SvgLoader";
import axios from "../../util/Api";
import moment from "../../util/moment";

const StudentFees = () => {
  const intl = useIntl();
  const [tableLoader, setTableLoader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [fees, setFees] = useState([]);
  const [query, setQuery] = useState("");
  const [totalRecord, setTotalRecord] = useState(0);
  const [modalShow, setModalShow] = useState({ isShow: false, data: "" });
  const pageLimit = process.env.REACT_APP_TABLE_PAGE_SIZE;

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Paid Date",
      render: (data) => {
        return moment(data.paid_date).format("Do MMM, YYYY");
      },
    },
    {
      title: "Fee",
      dataIndex: "paid_amount",
      key: "paid_amount",
      render: (amount) => {
        return parseFloat(amount).toFixed(3) + " KD";
      },
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      key: "payment_type",
    },
    {
      title: "Action",
      render: (data) => {
        return (
          <div>
            <Link
              to="#"
              onClick={() => setModalShow({ isShow: true, data: data })}
              className="btn btn-icon btn-flex btn-light-primary btn-sm me-1"
            >
              <KTSVG
                path="/media/icons/duotone/General/Visible.svg"
                className="svg-icon-3"
              />
            </Link>
            <Link
              to="#"
              className="btn btn-icon btn-flex btn-light-info btn-sm me-1"
            >
              <KTSVG
                path="/media/icons/duotone/Devices/Printer.svg"
                className="svg-icon-3"
              />
            </Link>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    setTableLoader(true);
    getData(1, query);
  }, []);

  const getData = (page, query) => {
    axios
      .post(`online_fee_payment/student_fees?page=${page}`, {
        search: query,
        limit: pageLimit,
      })
      .then(({ data }) => {
        setLoading(false);
        setTableLoader(false);
        if (data.result) {
          setFees(data.student_fees.data);
          setTotalRecord(data.student_fees.total);
        }
      });
  };

  const searchRecord = (query) => {
    setQuery(query);
    if (query.length > 2) {
      setTableLoader(true);
      getData(1, query);
    } else if (query.length == 0) {
      setTableLoader(true);
      getData(1, query);
    }
  };

  const handleTableChange = (pagination) => {
    setTableLoader(true);
    getData(pagination.current, query);
  };

  return (
    <>
      <Modal
        title="Fees Details"
        visible={modalShow.isShow}
        onCancel={() => setModalShow({ isShow: false, data: "" })}
        footer={null}
      >
        <div className="table-responsive">
          <table
            className="table align-middle table-striped fs-6 gy-5"
            id="kt_assignment_table"
          >
            <tbody className="fw-bold text-gray-600">
              <tr>
                <td>{"Total Paid Fees"}</td>
                <td>
                  {"KD " + parseFloat(modalShow.data.paid_amount).toFixed(3)}
                </td>
              </tr>
              <tr>
                <td>{"Payment Type"}</td>
                <td>{modalShow.data.payment_type}</td>
              </tr>
              {modalShow.data.payment_type == "cheque" ? (
                <tr>
                  <td>{"Cheque No."}</td>
                  <td>{modalShow.data.check_no}</td>
                </tr>
              ) : (
                <></>
              )}
              {modalShow.data.payment_type == "cheque" ? (
                <tr>
                  <td>{"Cheque Date"}</td>
                  <td>{modalShow.data.check_date}</td>
                </tr>
              ) : (
                <></>
              )}
              {modalShow.data.payment_type == "knet" ? (
                <tr>
                  <td>{"Bank Name"}</td>
                  <td>{modalShow.data.bank_name}</td>
                </tr>
              ) : (
                <></>
              )}
              {modalShow.data.payment_type == "knet" ? (
                <tr>
                  <td>{"Transaction Id"}</td>
                  <td>{modalShow.data.transaction_id}</td>
                </tr>
              ) : (
                <></>
              )}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* Toolbar Start */}
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
              {intl.formatMessage({ id: "online_fee_payment" })}
              <span className="h-20px border-gray-200 border-start mx-4"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-dark">
                  {intl.formatMessage({ id: "payment_history" })}
                </li>
                <li className="breadcrumb-item px-3">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-dark">
                  {intl.formatMessage({ id: "fee_payment_details" })}
                </li>
              </ul>
            </h1>
          </div>
        </div>
      </div>
      {/* Toolbar end */}

      {loading ? (
        <CircularProgress />
      ) : (
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-fluid">
            <div className={`card mb-5 mb-xxl-8 card-xxl-streatch`}>
              <div className="card-toolbar px-10 py-5">
                <div className="d-flex overflow-auto h-55px">
                  <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
                    <li className="nav-item">
                      <Link
                        className={`nav-link text-active-primary me-6 active`}
                        to="/online-fee-payment/history/student-fees"
                      >
                        {intl.formatMessage({
                          id: "fee",
                        })}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className={`nav-link text-active-primary me-6 false`}
                        to="/online-fee-payment/history/payment-history"
                      >
                        {intl.formatMessage({
                          id: "online_payment_history",
                        })}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card-header border-0 pt-6">
                <div className="card-title">
                  <div className="d-flex align-items-center position-relative my-1">
                    <span className="svg-icon svg-icon-1 position-absolute ms-6">
                      <KTSVG
                        path="/media/icons/duotone/General/Search.svg"
                        className="svg-icon-1"
                      />
                    </span>

                    <input
                      type="text"
                      data-kt-assignment-table-filter="search"
                      className="form-control form-control-solid w-250px ps-15"
                      placeholder={intl.formatMessage({
                        id: "search",
                      })}
                      onChange={(e) => searchRecord(e.currentTarget.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="card-body pt-5">
                <div className="table-responsive">
                  <Table
                    rowKey={"id"}
                    dataSource={fees}
                    columns={columns}
                    onChange={handleTableChange}
                    loading={tableLoader}
                    pagination={{
                      total: totalRecord,
                      defaultPageSize: pageLimit,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentFees;
